import {useSelector} from 'react-redux';
import {cloneCourse} from 'constants/url';
import authFetch from '../../../helpers/requests';

function useCloneCourse() {
  const token: string = useSelector(
    (state: any) => state.authentication.user.token,
  );
  return async (values: any) => {
    try {
      const response = await authFetch(
        `${cloneCourse}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
          },
          body: JSON.stringify(JSON.stringify(values)),
        },
        token,
      );
      return response;
    } catch (e) {
      return e;
    }
  };
}

export default useCloneCourse;
